<template>
	<div class="page_content learner_dashboard" aria-label="Learner Home Page">

		<div class="row page_content_container" v-if="isDataLoaded">
			<div class="col-12">

				<div class="row">
					<div class="col-6 pg_sec_head">
						<h1 class="hd_txt ace_sec_txt" :aria-label="$tf('welcomeHd') + userName">
							{{ $tf('welcomeHd') }} {{userName}}
						</h1>
		      </div>
					<div class="col-1 pg_sec_head">
		      </div>
				</div>

				<div class="row mb-5 mt-1" v-if="isFinancialInformationEnabled() && (userObject.userProfile && userObject.userProfile.dueDate)">
					<div class="col-6" :class="(userObject.userProfile.overDue) ? 'alert_msg_sec' : 'alert_msg_sec_yellow'" style="margin: auto;">
						<div class="row">
							<div class="col-10 msg_container">
								<span v-if="userObject.userProfile.overDue">
								  {{ $tf('billing.overdue', '', { email: 'billing@teachus.com' }) }}
								</span>
								<span v-if="!userObject.userProfile.overDue">
								  {{ $tf('billing.nextDue', '', { date: userObject.userProfile.dueDate, email: 'billing@teachus.com' }) }}
								</span>

							</div>
							<div class="col-2 btn_container">
								<b-btn @click="launchPaymentLink">
									{{ $tf('pay', 'pay') }}
								</b-btn>
							</div>
						</div>
					</div>
				</div>

				<template v-for="componentRow in learnerDashboardComponents">
					<component-row :program-guide="programGuide" :careerGoal="careerGoal" :component-row="componentRow"></component-row>
				</template>

			</div>
		</div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import { PACKAGE } from '../../../package_constants'
	import ComponentRow from './ComponentRow'
	import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-dashboard',
		components: {
      ComponentRow
    },
		data: () => {
			return {
				programGuide: '',
        careerGoal: {},
        careerGoalPragyaSoc: '',
				isDataLoaded: false,
				userObject: JSON.parse(localStore.getItem('userobj'))
			}
		},
		beforeMount () {
			this.populateDashboardData()
    },
    mounted () {
    	this.$root.$on('reloadLearnerDashboard', () => {
	      this.populateDashboardData()
	    })
    },
    computed: {
    	...mapState({
    		'enabledFeatures': state => state.institution.enabledFeatures,
    		'institution': state => state.institution.institution,
	      'learnerDashboardComponents': state => state.dashboard.learnerDashboardComponents
	    }),
			userName () {
        return this.userObject.firstName
      },
      isExplorePackageEnabled () {
	      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
	      if (exploreFeature) {
	        return exploreFeature.enabled
	      }
	      return false
	    }
		},
		methods: {
			...mapActions([
				'loadLearnerDashboardState',
	      'loadLearnerEnrolledProgram',
	      'loadLearnerEnrollmentData',
        'loadCareer'
	    ]),
	    async populateDashboardData () {
	    	let userObj = JSON.parse(localStore.getItem('userobj'))
	    	await this.loadLearnerDashboardState()
	    	await this.loadLearnerEnrollmentData()
        if (userObj.careerGoal) {
          this.careerGoalPragyaSoc = userObj.careerGoalPragyaSoc

          // Get Career
          this.careerGoal = await this.loadCareer({ code: this.careerGoalPragyaSoc, loadDataFromServer: true })
        }

        if (userObj.major1) {
		      this.programGuide = await this.loadLearnerEnrolledProgram()
          setTimeout(() => {
            this.isDataLoaded = true
          }, 0)
		    } else {
	      	this.isDataLoaded = true
	      }


	    },
	    isFinancialInformationEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Financial Information')
      },
      launchPaymentLink(){
        window.open(this.institution.invoicePaymentLink, '_blank')
      },
      isFlagEnabled (featureId, flagValue) {
        let learnerDB = this.enabledFeatures[featureId]
        if (learnerDB && learnerDB.enabled) {
          let flags = learnerDB.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].enabled
            }
          }
        }
        return false;
      }
	  }
	}
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerDashboard.vue